import React, { useState } from "react";
import { Configurations } from "../../../Utils/Configurations";
import ImagemFukyo from "../../Imagem-Fukyo/Imagem-Fukyo";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import axios from "axios";
import { withRouter } from 'react-router-dom';

const VideoPlaylistCard = (props) => {

    const { conteudo, indice, size, chamadaPlaylists, onMoveUp, onMoveDown } = props;

    const [modalExcluir, setModalExcluir] = useState(false);
    const [loadingExcluir, setLoadingExcluir] = useState(false);
    const [itemExcluir, setItemExcluir] = useState(null);

    const toggleVisivel = (item) => {
        const _body = {
            ativo: !item.ativo,
        };

        const config = new Configurations();
        axios.put(config.apiBasePath + `/playlist/video/${item.id}`, _body)
            .then((response) => {
                chamadaPlaylists()
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
            });
    }

    const toggleModalExcluir = (item) => {
        setModalExcluir(!modalExcluir)
        setItemExcluir(item)
    }

    const deletePlaylist = (item) => {
        setLoadingExcluir(true);

        const config = new Configurations();
        axios.delete(config.apiBasePath + `/playlist/video/${item.id}`)
            .then((response) => {
                setLoadingExcluir(false)
                toggleModalExcluir()
                chamadaPlaylists()
            })
            .catch(error => {
                console.log("ERROR: ", error)
                setLoadingExcluir(false)
            })
            .finally(() => {
            });
    }

    const editPlaylist = (id) => {
        props.history.push({
            pathname: `detalhes/${id}`,
        });
    }

    return (
        conteudo &&
        <>
            <div className="content-product pt-2 mt-3">
                <div className="card bg-white">
                    <div className={`${conteudo.ativo ? 'bg-purple' : 'bg-secondary'} text-white card-header`}>
                        <div className="row no-gutters">
                            <div className="col-4 border-white">
                                <span className="tipo-label d-flex align-items-center">
                                    Playlist
                                </span>
                            </div>
                            <div className="col-4 d-none d-md-block text-center">
                                <button className="btn btn-outline-light" onClick={() => editPlaylist(conteudo.id)}>Editar</button>
                            </div>
                            <div className="col-4 text-right border-white d-flex justify-content-end align-items-center">
                                <i className={`far fa-eye-slash icones-destaques-ativos cursor-pointer`} onClick={() => toggleVisivel(conteudo)}></i>

                                <span className={`${conteudo.ativo ? 'text-purple' : 'text-secondary'} mx-3 badge bg-white`}>{conteudo.ativo ? 'Disponível' : 'Indisponível'}</span>
                                {conteudo.ativo &&
                                    <>
                                        <i className={'cursor-pointer fas fa-arrow-up icones-destaques-ativos px-3 ' + (indice === 0 ? 'd-none' : null)} onClick={() => onMoveUp()} ></i>
                                        <i className={'cursor-pointer fas fa-arrow-down icones-destaques-ativos px-3 ' + (indice === (size - 1) ? 'd-none' : null)} onClick={() => onMoveDown()} ></i>
                                    </>
                                }
                                <i className="far fa-trash-alt ml-1 mr-1 cursor-pointer" onClick={() => toggleModalExcluir(conteudo)}></i>
                            </div>
                        </div>
                    </div>
                    <div className="card-body pt-3">
                        <div className="row no-gutters">
                            <div className="col-3 d-lg-block d-none">
                                <ImagemFukyo
                                    className={`img img-fluid`}
                                    src={conteudo.image}
                                    alt={`imagem-playlist`}
                                />
                            </div>
                            <div className="col-lg-9 col-12 px-lg-4 px-0">
                                <p className="infos-ativos"><strong>Título:</strong> {conteudo.nomePlaylist} </p>
                                <p className="infos-ativos"><strong>Categoria:</strong> {conteudo.categoria} </p>
                                <p className="infos-ativos"><strong>Total de Vídeos:</strong> {conteudo.quantidadeItens || 0} </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={modalExcluir} toggle={toggleModalExcluir} >
                <ModalHeader toggle={toggleModalExcluir}>Remover playlist</ModalHeader>
                <ModalBody>
                    <p className="m-0">Deseja excluir a playlist <strong>{conteudo.nomePlaylist}</strong> da lista?</p>
                </ModalBody>
                <ModalFooter>
                    {loadingExcluir ? (
                        <div className="spinner-border spinner-border-sm text-danger" role="status" />
                    ) : (
                        <Button disabled={loadingExcluir} color={`danger`} onClick={() => deletePlaylist(itemExcluir)}>Excluir</Button>
                    )}
                    {' '}<Button color="secondary" onClick={toggleModalExcluir}>cancelar</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default withRouter(VideoPlaylistCard);
